import React, {useRef, useEffect} from "react";
import {useHistory} from "react-router-dom";
import styled from "styled-components";
import {StyleButtonRound} from "./StyleButton";
import {StyleImg} from "components/Common/StyleImg";

const BackButtonStyled = styled(StyleButtonRound)`
  -webkit-tap-highlight-color: transparent;
  border: 1px solid var(--line-strong) !important;
  &:hover,
  &:active,
  &:focus {
    background-color: var(--hover) !important;
    border-color: var(--fg) !important;
    outline: none;
  }
`;

interface Props {
  onClick?: () => void;
  inBarLayout?: boolean;
  marginTop?: string;
}

function GoBackButton({onClick, inBarLayout, marginTop}: Props) {
  const history = useHistory();
  const buttonRef = useRef<any>(null);
  const resolvedMarginTop = marginTop !== undefined ? marginTop : inBarLayout ? "7px" : "49px";

  const performBackRef = useRef<(() => void) | null>(null);
  performBackRef.current = () => {
    if (onClick) {
      onClick();
    } else {
      history.goBack();
    }
  };

  const performBack = () => performBackRef.current();

  useEffect(() => {
    const el = buttonRef.current;
    if (!el) return;
    const handleCapture = (e) => {
      e.stopPropagation();
      e.preventDefault();
      setTimeout(() => performBackRef.current(), 0);
    };
    el.addEventListener("click", handleCapture, true);
    return () => el.removeEventListener("click", handleCapture, true);
  }, []);

  return (
    <BackButtonStyled
      ref={buttonRef}
      color="var(--fg)"
      border="none"
      position="relative"
      padding="0"
      fontSize="1.3rem"
      backgroundColor="var(--card)"
      onClick={(e) => {
        e.stopPropagation();
        setTimeout(() => performBack(), 0);
      }}
      marginTop={resolvedMarginTop}
      id="back-button-bar"
      width="40px"
      height="40px"
      borderRadius="50%"
      display="flex"
      justifyContent="center"
      style={{
        alignItems: "center",
        zIndex: 100002,
        pointerEvents: "auto"
      }}
    >
      <StyleImg width="20px" height="20px" src="/assets/icons/icon-arrow-left.svg" alt="envolop-logo" />
    </BackButtonStyled>
  );
}

export default GoBackButton;
